import bookingsTabsTemplate from '../../member/member-bookings/member_bookings_tabs.html';

function MemberBookingsDirective() {
    'ngInject';

    return {
        templateUrl: bookingsTabsTemplate.id,
        scope: {
            member: '='
        }
    };
}

angular
    .module('BBMember')
    .directive('memberBookings', MemberBookingsDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/member/member-bookings/member_bookings.directive.js